import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=2dedc691&"
import script from "./Slider.vue?vue&type=script&lang=js&"
export * from "./Slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dedc691')) {
      api.createRecord('2dedc691', component.options)
    } else {
      api.reload('2dedc691', component.options)
    }
    module.hot.accept("./Slider.vue?vue&type=template&id=2dedc691&", function () {
      api.rerender('2dedc691', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Slider.vue"
export default component.exports